const defaultDetailForm = {
    numPrincipal: '',
    titular: '',
    document: '',
    typeof_document: null,
    fijos: [],
    moviles: [],
    contratado: '',
    direccionFact: '',
    direccionEnv: '',
    DireccionInsFixed: '',
    iniFechaPerm: '',
    finFechaPerm: '',
}

export {defaultDetailForm};